import React, { Component } from 'react';
import { connect } from 'react-redux';
import authUtils from '../../auth/utils';
import WeeklyProgramCalendar from '../weeklyPrograms/calendar';
import utils from '../../common/services/utils';
import { loadWeeklyProgram } from './actions';
import { initialize } from 'redux-form';

class ChildAttendance extends Component {

	constructor(props) {
		super(props);
		this.handleSelectWeeklyProgram = this.handleSelectWeeklyProgram.bind(this);
		this.initializeFilter = this.initializeFilter.bind(this);
	}

	initializeFilter(form, data, fields) {
		return this.props.initialize(form, data, fields);
	}

	handleSelectWeeklyProgram(day, weeklyProgramItem) {
		const { history } = this.props;
		history.push(`/lessonAttendance/manage?weeklyProgramItemId=${weeklyProgramItem.id}&centerId=${weeklyProgramItem.centerId}&termId=${weeklyProgramItem.termId}`);
	}

	render() {
		const {
			terms, centers, weeklyPrograms, currentUser,
			loadWeeklyProgram, weeklyProgramFilter, enableTrials, enableMakeUps, timetableViewType
		} = this.props;

		return (
			<WeeklyProgramCalendar
				kindergarten={false}
				onWeeklyProgramItemClick={this.handleSelectWeeklyProgram}
				weeklyPrograms={weeklyPrograms}
				currentUser={currentUser}
				centers={centers}
				terms={terms}
				loadWeeklyProgram={loadWeeklyProgram}
				weeklyProgramFilter={weeklyProgramFilter}
				initializeFilter={this.initializeFilter}
				showAvailabilityColor
				showSeparateSingleLessons={true}
				enableTrials={enableTrials}
				enableMakeUps={enableMakeUps}
				timetableViewType={timetableViewType}
			/>
		);
	}
}

const mapStateToProps = state => {
	const {
		entities: { weeklyPrograms, centers, terms },
		auth: { currentUser },
		configuration: { franchisor },
		filters
	} = state;

	const lessonAttendanceWeeklyProgramFilter = filters.lessonAttendanceWeeklyProgram.all || { ids: [], filter: {}, loading: false };
	const onlineCenters = utils.filter(centers, center => center.isOnline && center.territory && center.territory.isOnline);
	const activeWeeklyPrograms = utils.filter(weeklyPrograms, p => !p.isDeleted);

	return {
		weeklyPrograms: activeWeeklyPrograms,
		centers: onlineCenters,
		terms: terms,
		currentUser,
		enableTrials: franchisor.enableTrials,
		enableMakeUps: franchisor.enableMakeUps,
		timetableViewType: franchisor.timetableViewType,
		weeklyProgramFilter: lessonAttendanceWeeklyProgramFilter
	};
};

const mapDispatchToProps = {
	loadWeeklyProgram,
	initialize
}

export default connect(mapStateToProps, mapDispatchToProps)(ChildAttendance);